import { Provider } from "react-redux";
import appStore from "./utils/appStore";
import Header from "./components/Header";
import Error from "./components/Error";
import { Outlet, createBrowserRouter } from "react-router-dom";
import Login from "./components/Login";
import Browse from "./components/Browse";
import SearchShimmer from "./components/SearchShimmer";
import { Suspense, lazy } from "react";
import AiSearch from "./components/AiSearch";

import MovieShimmer from "./components/MovieShimmer";

const Explore = lazy(() => import("./components/Explore"));
const MoviePage = lazy(() => import("./components/MoviePage"));

const App = () => {
  return (
    <Provider store={appStore}>
      <Header />
      <Outlet />
    </Provider>
  );
};

export const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Login />,
      },
      {
        path: "/browse",
        element: <Browse />,
      },
      {
        path: "/aisearch",
        element: (
          <Suspense fallback={<SearchShimmer />}>
            <AiSearch />
          </Suspense>
        ),
      },
      {
        path: "/explore",
        element: (
          <Suspense fallback={<SearchShimmer />}>
            <Explore />
          </Suspense>
        ),
      },
      {
        path: "/browse/movie/:id",
        element: (
          <Suspense fallback={<MovieShimmer />}>
            <MoviePage />
          </Suspense>
        ),
      },
    ],
    errorElement: <Error />,
  },
]);

export default App;
